export default __webpack_public_path__ + "static/media/blank-profile.571faac8.png";